module.exports = __webpack_public_path__ + "img/FR11128.00bb21aa.png";